import React from 'react';
import { Link } from 'react-router-dom';

const PageHeader = ({ title, breadcrumbs = [], actions }) => (
  <div className="page-header">
    <div className="page-block flex items-center justify-between flex-wrap gap-3">
      <div className="page-header-title">
        <h5 className="mb-0 font-medium text-theme-headings">{title}</h5>
      </div>
      {breadcrumbs.length > 0 && (
        <ul className="breadcrumb">
          {breadcrumbs.map((crumb, index) => {
            const isLast = index === breadcrumbs.length - 1;
            return (
              <li key={crumb.to || crumb.label} className="breadcrumb-item">
                {isLast || !crumb.to ? (
                  <span aria-current={isLast ? 'page' : undefined}>{crumb.label}</span>
                ) : (
                  <Link to={crumb.to}>{crumb.label}</Link>
                )}
              </li>
            );
          })}
        </ul>
      )}
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
  </div>
);

export default PageHeader;
